
import { supabase } from "@/integrations/supabase/client";
import { useQuery } from "@tanstack/react-query";
import { EventVenue } from "@/components/event-card/types";

export const useVenuesBySuburbs = (suburbs: string[] = []) => {
  return useQuery({
    queryKey: ['venues', 'by-suburbs', suburbs],
    queryFn: async () => {
      if (!suburbs.length) {
        return [];
      }

      const { data, error } = await supabase
        .from('venues')
        .select('*')
        .in('suburb', suburbs)
        .eq('archived', false);

      if (error) {
        console.error('Error fetching venues by suburbs:', error);
        throw error;
      }

      // Transform the venue data to match EventVenue format
      return data.map(venue => ({
        name: venue.name || '',
        address: venue.address || '',
        image_url: venue.image_url || '',
        style: venue.style || '',
        price_range: venue.price_range || '',
        venue_id: venue.venue_id || '',
        website_url: venue.website_url || '',
        instagram_handle: venue.instagram_handle || '',
        google_maps_link: venue.google_maps_link || ''
      })) as EventVenue[];
    },
    enabled: suburbs.length > 0,
  });
};
